import setConflictsRequestStatus from '../actions/setConflictsRequestStatus';
import { mutator } from 'satcheljs';

export default mutator(setConflictsRequestStatus, actionMessage => {
    const { status, meetingRequestViewState } = actionMessage;
    meetingRequestViewState.conflictsRequestStatus = status;
});
